import BasePageTitleContainer from "../../../components/form/BasePageTitleContainer";
import { TotalDurationAreaChart } from "../../../components/dashboard/charts/v2/TotalDurationAreaChart";
import { IntegrationItem } from "../../../models/integration-item.model";

export const RunAttemptsDurationCard = ({
  runs,
}: {
  runs: IntegrationItem[];
}) => {
  return (
    <BasePageTitleContainer
      mt="0px"
      padding="24px"
      height="100%"
      width="100%"
      display="flex"
      flexDirection="column"
      flexGrow={1}
      maxWidth="35%"
    >
      <div className="flex flex-col h-full w-full min-h-0">
        <div className="text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground mb-3 shrink-0">
          Duration — {runs.length} recent attempts
        </div>
        <div className="flex-1 min-h-0 w-full">
          <TotalDurationAreaChart data={runs} />
        </div>
      </div>
    </BasePageTitleContainer>
  );
};
